import React, { useState, useEffect, useRef } from "react";
import { styled } from '@material-ui/core/styles';
import { API } from "aws-amplify";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import RunIcon from '@material-ui/icons/PlayCircleFilled';
import CancelIcon from '@material-ui/icons/Cancel';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LoadingModal from "./LoadingModal";

export default function TabParse(props) {
    const { updateConfig, startPipeline, config, disabled } = props;
    const [promptUser, setPromptUser] = useState(config && config.options && config.options.promptUser ? config.options.promptUser : "");
    const [promptSys, setPromptSys] = useState(config && config.options && config.options.promptSys ? config.options.promptSys : "");
    const [copied, setCopied] = useState(false);
    const [resultsData, setResultsData] = useState("");
    const [isRunning, setIsRunning] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const [resOpen, setResOpen] = useState(false);
    const [resultsTitle, setResultsTitle] = useState('');
    const [resultsStatus, setResultsStatus] = useState('');
    const startTimeRef = useRef(0);
    const [completePipeline, setCompletePipeline] = useState(false);

    const ExpandMore = styled((props) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));
    const run = async (e) => {
        e.preventDefault();
        resetResults();
        startTimeRef.current = Date.now();
        setResultsData('Parsing...')
        setResOpen(true);
        //runParser();
        startPipeline("PAR", completePipeline);
    }
    const cancel = async (e) => {
        e.preventDefault();
        setResultsData('Cancelling ...');
        setIsCancelling(true);
    }

    function resetResults() {
        setResultsTitle('');
        setResultsData('');
        setResOpen(false);
    }


    const saveConfig = async () => {
        const body = { type: "parse", values: { options: { promptSys: promptSys, promptUser: promptUser } } };
        await updateConfig(body);
    }

    const copyToClipboard = (e) => {
        navigator.clipboard.writeText(resultsData)
            .then(() => {
                console.log("Text copied to clipboard!");
                setCopied(true);
                setTimeout(() => setCopied(false), 1500); // hide after 2 sec
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    }

/*
    useEffect(() => {
        let pollingInterval;
        if (isRunning) {
            pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
        }
        try {
            return () => {
                clearInterval(pollingInterval);
            } // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }
    }, [isRunning]); //

    const updateResultsStatus = () => {
        const timeDiff = (Date.now() - startTimeRef.current) / 1000;
        setResultsStatus(timeDiff)

    }
*/

    /////// Step Specific Stuff /////////////////////////////////
/*
    async function runParser() {
        console.log(docRef.current);
         startPipeline(true, "Parsing", completePipeline);
        parseDoc({ type: "bufferParse", doc: docRef.current, projectType: project.type, fullPipeline: completePipeline }) // project id is doc pk
            .then(resultParse => {
                console.log("Got data:", resultParse);
                const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
                const { id, status } = data;
                //setJobId(id);
                if (id && status) {
                    // do nowt
                } else {
                    startPipeline(false, "Parsing", completePipeline, { error: true, message: "Invalid id and status returned from bufferParse request", details: { id: id, status: status } });
                }

            }).catch(err => {
                startPipeline(false, "Parsing", completePipeline, { error: true, message: `Error in bufferParse request: ${err.message}` });
                //setIsRunning(false);
                setResultsData("parsing failed: " + err.message);
                console.log('err');
                console.error('Error uploading file:', err);
            });
    }

    function parseDoc(body) {
        console.log(body);
        return API.post("findigai", "/parse", {
            body: body
        });
    }
        */
    /*
        function synthesize(body) {
            console.log(body);
            return API.post("findigai", "/synthesize", {
                body: body
            });
        }
    */



/*
    useEffect(() => {
        let pollingInterval;
        if (isRunning) {
            pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
        }
        try {
            return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }
    }, [isRunning, jobId]);

    const pollParsingStatus = async () => {
        if (isRunning) {
            if (isCancelling) {
                setIsRunning(false);
                setResultsData("Cancelled ok!");
                setIsCancelling(false);
                // should request a cancellation to llamaparse here
            } else {
                try {
                    if (!jobId) return;
                    if (jobId === "synthesize") {
                        const docResult = await getDocument(docRef.current.pk, docRef.current.itemId);
                        console.log(docResult.document.pipeline);
                        if (docResult.document.pipeline.state === "complete") {
                            setJobId(null);
                            updateSteps(-1, false);
                            onDocUpdated(docResult.document);
                            setResultsData("parsing completed OK ");
                            setIsRunning(false);
                        }
                    } else {
                        const resultJob = await parseDoc({ type: "job", id: jobId, doc: docRef.current });
                        const { status } = resultJob.data;
                        console.log(status);
                        if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
                            if (status === "SUCCESS") {
                                setJobId("synthesize"); // start checking for the synth process to complete
                            } else {
                                updateSteps(-1, false);
                                setResultsData("parsing failed: " + status);
                                console.log("DOC PARSING FAILED: ", status)
                                setIsRunning(false);
                            };
                        }
                    }
                } catch (error) {
                    updateSteps(-1, false);
                    setIsRunning(false);
                    setResultsData("parsing failed: " + error.message);
                    console.error('Error checking parsing status:', error);
                }
            }
        }
    };
*/

    function getDocument(prjid, docid) {
        return API.get("findigai", "/documents/" + prjid + "/" + docid);
    }
    
    return (

        <>
            {/* RESULTS SECTION */}

            <Box mt={1}>
                <Paper style={{ backgroundColor: "#e8f6f3" }}>
                    <Box p={1} >
                        <Box display="flex" alignItems='center' flexDirection="row" >
                            <Box mx={1} >
                                <Tooltip title="Run">
                                    <IconButton
                                        onClick={run}
                                        disabled={isRunning || disabled}
                                        size="small"
                                    >
                                        <RunIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box mx={1}>
                                <Tooltip title="Clear results">
                                    <IconButton
                                        onClick={cancel}
                                        disabled={!isRunning || disabled}
                                        size="small"
                                    >
                                        <CancelIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>



                            <Box mx={1} display="flex" alignItems="center">
                                <FormControlLabel
                                    style={{ margin: 0, display: "flex", alignItems: "center" }}
                                    control={
                                        <Checkbox
                                            checked={completePipeline}
                                            onChange={(e) => setCompletePipeline(e.target.checked)}
                                            color="primary"
                                            size="small"
                                        />
                                    }
                                    label="Complete full pipeline from here"
                                />
                            </Box>



                            <Box mx={1} display="flex" alignItems="center" >
                                <Typography variant="body2" style={{ color: 'green', fontSize: '0.8rem', margin: 0, display: "flex", alignItems: "center" }}>
                                    &nbsp;&nbsp;&nbsp;{Number(resultsStatus).toFixed(2) + " seconds"}
                                </Typography>
                            </Box>
                            <Box sx={{ flexGrow: 1 }} ></Box>
                            <Box mx={1} >
                                <Tooltip title="Copy results to clipboard">
                                    <IconButton
                                        onClick={copyToClipboard}
                                        disabled={disabled}
                                        size="small"
                                    >
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                            </Box>
                            <ExpandMore
                                color="primary"
                                expand={resOpen}
                                onClick={() => { setResOpen(!resOpen) }}
                                aria-expanded={resOpen}
                                aria-label="show results"
                                size="small"
                                id="resOpen">
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Box>
                        <Collapse in={resOpen} timeout="auto" unmountOnExit>
                            <>
                                <h6><u>{resultsTitle}</u></h6>
                                <Box m={2}>
                                    <Paper>
                                        <Box m={1} py={1}>
                                            <div style={{ whiteSpace: 'pre-wrap' }}>{resultsData}</div>
                                        </Box>
                                    </Paper>
                                </Box>
                            </>
                        </Collapse>
                    </Box>

                </Paper>
            </Box>

            {/* OPTIONS SECTION */}

            <Box mt={1}>
                <Paper style={{ backgroundColor: "#f2f2ff" }}>
                    <Box p={2}>
                        <Box pv={2} pl={0.5}>
                            <h6>System prompt (Append)</h6>
                        </Box>
                        <TextareaAutosize
                            minRows={1}
                            disabled={isRunning || disabled}
                            placeholder="<empty>"
                            value={promptSys}
                            onChange={(e) => setPromptSys(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                            }}
                        />
                        <Box pt={3} pb={0} pl={0.5} >
                            <h6>User prompt </h6>
                        </Box>
                        <TextareaAutosize
                            minRows={1}
                            disabled={isRunning || disabled}
                            placeholder="<empty>"
                            value={promptUser}
                            onChange={(e) => setPromptUser(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                            }}
                        />
                    </Box>
                </Paper>
            </Box>
            {isRunning &&
                <LoadingModal open={isRunning} message={"??????????..."} message2={"processText" + "..."} message3={Number(resultsStatus).toFixed(1) + " seconds"} />
            }

        </>
    )
};